import { Flex } from '@chakra-ui/react';
import { FormFeedback, OutlineCard } from '@morressier/alembic';
import { useFormContext } from 'react-hook-form';
import { FieldLabel } from 'src/components/Field';
import { ISubmissionFormData } from 'src/contexts/FormContext';
import { RadioGroup } from 'src/components/RadioGroup';
import { FormFieldGeneratedDataset } from '@publishing-engine/domain/types/article';
import { get } from 'lodash';

const GeneratedDataset = ({
  config,
  hideLabel = false
}: {
  config: FormFieldGeneratedDataset;
  hideLabel?: boolean;
}) => {
  const {
    formState: { errors },
    control
  } = useFormContext<ISubmissionFormData>();
  const {
    params: { validations, labels },
    caseDataFields: { main: field }
  } = config;
  const error = get(errors, field);

  const content = (
    <Flex flexDirection="column" gap={4} width="100%">
      {hideLabel ? (
        <FieldLabel label="" subText={labels.subtitle} isRequired={false} />
      ) : (
        <FieldLabel
          label={labels.main}
          subText={labels.subtitle}
          isRequired={validations.required}
          helpText={labels.helpText}
        />
      )}
      <RadioGroup
        control={control}
        name={field}
        options={[
          {
            value: true,
            children: labels.options['true']?.main
          },
          {
            value: false,
            children: labels.options['false']?.main
          }
        ]}
      />
      {error ? (
        <FormFeedback variant="error">
          Indicate whether your work generated any major datasets before
          proceeding.
        </FormFeedback>
      ) : null}
    </Flex>
  );

  if (hideLabel) return content;

  return (
    <OutlineCard width="100%" padding={4}>
      {content}
    </OutlineCard>
  );
};

export default GeneratedDataset;
